document.addEventListener('DOMContentLoaded', function () {
  const galleries = document.querySelectorAll('[data-cos-gallery="true"]');

  if (!galleries.length) return;

  const desktopQuery = window.matchMedia('(min-width: 750px)');

  galleries.forEach(setupGallery);

  function setupGallery(mediaGallery) {
    const list = mediaGallery.querySelector('.product__media-list');
    const items = list ? Array.from(list.querySelectorAll('.product__media-item')) : [];
    const paginationContainer = mediaGallery.querySelector('[data-cos-pagination]');

    if (!items.length || !paginationContainer) return;

    function initDesktop() {
      if (!desktopQuery.matches) return;

      // 1) groups banaao: 2,1,2,1 pattern
      const groups = buildGroups(items); // array of arrays
      // 2) pagination bars create karo
      createDots(paginationContainer, groups);
      // 3) scroll tracking
      setupObserver(groups, paginationContainer);
    }

    function destroyDesktop() {
      paginationContainer.innerHTML = '';
      // IntersectionObserver ko automatically garbage collect hone denge
    }

    // agar width change ho to handle karo
    desktopQuery.addEventListener('change', function (e) {
      if (e.matches) {
        initDesktop();
      } else {
        destroyDesktop();
      }
    });

    // initial init
    if (desktopQuery.matches) {
      initDesktop();
    }
  }

  function buildGroups(items) {
    const groups = [];
    const pattern = [2, 1]; // 2 items, phir 1 item, phir repeat
    let patternIndex = 0;
    let i = 0;
    let groupIndex = 0;

    while (i < items.length) {
      const size = pattern[patternIndex];
      const groupItems = items.slice(i, i + size);

      if (!groupItems.length) break;

      groups.push(groupItems);

      groupItems.forEach(function (el) {
        el.dataset.galleryGroup = String(groupIndex);
      });

      i += size;
      groupIndex += 1;
      patternIndex = 1 - patternIndex; // 0 -> 1 -> 0 -> 1...
    }

    return groups;
  }

  function createDots(container, groups) {
    container.innerHTML = '';

    groups.forEach(function (groupItems, index) {
      const dot = document.createElement('span');
      dot.className = 'slider-indicator' + (index === 0 ? ' is-active' : '');
      dot.dataset.galleryPage = String(index);

      // click -> scroll to first item of group
      dot.addEventListener('click', function () {
        const target = groupItems[0];
        if (!target) return;
        const rect = target.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        const offsetTop = rect.top + scrollTop;

        window.scrollTo({
          top: offsetTop - 80, // thora upar offset, adjust if sticky header hai
          behavior: 'smooth'
        });
      });

      container.appendChild(dot);
    });
  }

  function setupObserver(groups, paginationContainer) {
    const dots = Array.from(paginationContainer.querySelectorAll('.slider-indicator'));
    if (!dots.length) return;

    const anchors = groups.map(function (groupItems, index) {
      const anchor = groupItems[0];
      if (anchor) {
        anchor.dataset.galleryPage = String(index);
      }
      return anchor;
    }).filter(Boolean);

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          const page = entry.target.dataset.galleryPage;
          if (page == null) return;

          dots.forEach(function (dot) {
            dot.classList.toggle('is-active', dot.dataset.galleryPage === page);
          });
        });
      },
      {
        threshold: 0.5 // item ka ~50% visible ho to active
      }
    );

    anchors.forEach(function (anchor) {
      observer.observe(anchor);
    });
  }
});

// document.addEventListener('DOMContentLoaded', function () {
//   const wrapper = document.querySelector('.grid__item.product__media-wrapper');
//   const pagination = document.querySelector('.slider-buttons.desktop_pagination');

//   if (!wrapper || !pagination) return;

//   const desktopQuery = window.matchMedia('(min-width: 750px)');

//   function updateBodyScrolling() {
//     // sirf desktop par chalayega
//     if (!desktopQuery.matches) {
//       wrapper.classList.remove('body_scrolling');
//       return;
//     }

//     const wrapperRect = wrapper.getBoundingClientRect();
//     const paginationRect = pagination.getBoundingClientRect();

//     // JAB wrapper ka bottom pagination ke bottom ko touch ya cross kare
//     // (scroll down) -> class ADD
//     // JAB wrapper ka bottom pagination ke bottom se neeche aa jaye
//     // (scroll up) -> class REMOVE
//     if (wrapperRect.bottom <= paginationRect.bottom) {
//       wrapper.classList.add('body_scrolling');
//     } else {
//       wrapper.classList.remove('body_scrolling');
//     }
//   }

//   // initial state
//   updateBodyScrolling();

//   // scroll & resize pe check karo
//   document.addEventListener('scroll', updateBodyScrolling, { passive: true });
//   window.addEventListener('resize', updateBodyScrolling);
// });

// document.addEventListener('DOMContentLoaded', function () {
//   const wrapper = document.querySelector('.grid__item.product__media-wrapper');
//   const pagination = document.querySelector('.slider-buttons.desktop_pagination');

//   if (!wrapper || !pagination) return;

//   const desktopQuery = window.matchMedia('(min-width: 750px)');

//   function updatePaginationOpacity() {
//     // sirf desktop pe kaam kare
//     if (!desktopQuery.matches) {
//       pagination.style.opacity = '';
//       return;
//     }

//     const wrapperRect = wrapper.getBoundingClientRect();
//     const paginationRect = pagination.getBoundingClientRect();

//     // jis point par bottom line touch kare
//     const fadeStart = paginationRect.bottom;  // wrapper.bottom == fadeStart  -> opacity ≈ 0.99
//     const fadeEnd = 0;                        // wrapper.bottom top of viewport -> opacity 0

//     let opacity = 0.99;

//     if (wrapperRect.bottom <= fadeStart) {
//       // wrapper ka bottom pagination se kitna upar chala gaya
//       const distance = Math.max(fadeStart - wrapperRect.bottom, 0);
//       const maxDistance = Math.max(fadeStart - fadeEnd, 1); // normalize

//       // t: 0 (just touched) -> 1 (fade completely done)
//       const t = Math.min(distance / maxDistance, 1);

//       // 0.99 se 0 tak interpolate
//       opacity = 0.99 * (1 - t);
//     } else {
//       // abhi tak touch nahi kiya -> full visible
//       opacity = 0.99;
//     }

//     // safety clamp
//     if (opacity < 0) opacity = 0;
//     if (opacity > 1) opacity = 1;

//     pagination.style.opacity = opacity.toFixed(3);
//   }

//   // initial state
//   updatePaginationOpacity();

//   // scroll / resize par update
//   document.addEventListener('scroll', updatePaginationOpacity, { passive: true });
//   window.addEventListener('resize', updatePaginationOpacity);
// });

document.addEventListener('DOMContentLoaded', function () {
  const wrapper = document.querySelector('.grid__item.product__media-wrapper');
  const pagination = document.querySelector('.slider-buttons.desktop_pagination');

  if (!wrapper || !pagination) return;

  const desktopQuery = window.matchMedia('(min-width: 750px)');

  function updatePaginationOpacity() {
    // Sirf desktop pe kaam kare
    if (!desktopQuery.matches) {
      pagination.style.opacity = '';
      return;
    }

    const wrapperRect = wrapper.getBoundingClientRect();
    const vh = window.innerHeight || document.documentElement.clientHeight;

    // Wrapper ka CENTER (50%)
    const wrapperCenter = wrapperRect.top + wrapperRect.height / 2;

    // Fade start / end:
    const fadeStart = vh * 0.5; // viewport ka center (50%)
    const fadeEnd = 0;          // viewport top

    let opacity = 0.99;

    if (wrapperCenter <= fadeStart) {
      // Jaise hi center viewport 50% se upar jana shuru kare
      const distance = Math.max(fadeStart - wrapperCenter, 0);
      const maxDistance = Math.max(fadeStart - fadeEnd, 1); // normalize 0..1

      // t: 0 (center at 50%) → 1 (center at top)
      const t = Math.min(distance / maxDistance, 1);

      // 0.99 se 0 tak interpolate
      opacity = 0.99 * (1 - t);
    } else {
      // Center abhi bhi viewport 50% se neeche hai → full opacity
      opacity = 0.99;
    }

    // clamp
    if (opacity < 0) opacity = 0;
    if (opacity > 1) opacity = 1;

    pagination.style.opacity = opacity.toFixed(3);
  }

  // initial state
  updatePaginationOpacity();

  // scroll / resize par update
  document.addEventListener('scroll', updatePaginationOpacity, { passive: true });
  window.addEventListener('resize', updatePaginationOpacity);
});
